import { render } from "./FleetManagement.vue?vue&type=template&id=4c2e31de&scoped=true"
import script from "./FleetManagement.vue?vue&type=script&lang=js"
export * from "./FleetManagement.vue?vue&type=script&lang=js"

import "./FleetManagement.vue?vue&type=style&index=0&id=4c2e31de&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c2e31de"]])

export default __exports__